export const VGP_SUPPORTED_MAKE_VEHICLE_TYPES: Record<string, readonly string[]> = {
  MAKE_VOLKSWAGEN: ['VEHICLETYPE_PASSENGER_CAR', 'VEHICLETYPE_VAN'],
  MAKE_SKODA: ['VEHICLETYPE_PASSENGER_CAR'],
  MAKE_CUPRA: ['VEHICLETYPE_PASSENGER_CAR'],
  MAKE_SEAT: ['VEHICLETYPE_PASSENGER_CAR'],
};

export const isVgpSupportedVehicle = (
  makeKey: string | undefined | null,
  vehicleType: string | undefined | null
): boolean => {
  if (!makeKey || !vehicleType) {
    return false;
  }

  return VGP_SUPPORTED_MAKE_VEHICLE_TYPES[makeKey]?.includes(vehicleType) ?? false;
};
